/**
 * Centralized SEO configuration per route.
 *
 * Single source of truth — data lives in `seo-routes.json`, consumed by:
 *   1. `useDocumentMeta` hook (runtime, for SPA navigation — Google + modern crawlers).
 *   2. The post-build pre-render script (`scripts/generate-route-html.js`) which
 *      writes per-route `build/{route}/index.html` so non-JS scrapers (LinkedIn,
 *      Facebook, iMessage, Slack, Discord) get a proper preview.
 */
import seoData from "./seo-routes.json";

export const SITE_ORIGIN = seoData.siteOrigin;
export const SITE_NAME = seoData.siteName;
export const TWITTER_HANDLE = seoData.twitterHandle;
export const SEO_ROUTES = seoData.routes;
export const DEFAULT_SEO = SEO_ROUTES["/"];

export function getSeoForPath(path) {
  if (!path) return DEFAULT_SEO;
  const normalized = path !== "/" && path.endsWith("/") ? path.slice(0, -1) : path;
  return SEO_ROUTES[normalized] || DEFAULT_SEO;
}

export function canonicalUrlFor(path) {
  const normalized = path === "/" ? "/" : path.replace(/\/+$/, "");
  return `${SITE_ORIGIN}${normalized}`;
}
